import React from "react"

const FacilityAuditTrailContext = React.createContext(null)

export default FacilityAuditTrailContext
